import React, { useState } from 'react';
import { InsuranceManager } from './InsuranceManager';
import { CertificationsManager } from './CertificationsManager';
import { TaxComplianceManager } from './TaxComplianceManager';
import { Shield, Award, FileText, Store } from 'lucide-react';

export const InsuranceHub: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'insurance' | 'certifications' | 'tax' | 'marketplace'>('insurance');

  const tabs = [
    { id: 'insurance' as const, label: 'Insurance Policies', icon: Shield },
    { id: 'certifications' as const, label: 'Licenses & Certifications', icon: Award },
    { id: 'tax' as const, label: 'Tax Documents', icon: FileText },
    { id: 'marketplace' as const, label: 'Get Quotes', icon: Store }
  ];

  return (
    <div className="space-y-6">
      <div className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-blue-900 rounded-2xl p-8 overflow-hidden">
        <div className="absolute inset-0 bg-grid-white/[0.05] bg-[size:20px_20px]"></div>
        <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl"></div>
        <div className="relative">
          <div>
            <h1 className="text-3xl font-bold text-white mb-2">Insurance & Compliance</h1>
            <p className="text-slate-300">Manage your credentials and coverage</p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-lg">
        <div className="border-b border-slate-200">
          <div className="flex">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex-1 px-6 py-4 font-medium transition-all flex items-center justify-center space-x-2 ${
                  activeTab === tab.id
                    ? 'text-blue-700 border-b-2 border-blue-600 bg-blue-50'
                    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                }`}
              >
                <tab.icon className="w-5 h-5" />
                <span>{tab.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="p-6">
          {activeTab === 'insurance' && <InsuranceManager />}
          {activeTab === 'certifications' && <CertificationsManager />}
          {activeTab === 'tax' && <TaxComplianceManager />}
          {activeTab === 'marketplace' && (
            <div className="text-center py-12">
              <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center mx-auto mb-4 shadow-lg">
                <Store className="w-10 h-10 text-white" />
              </div>
              <h3 className="font-bold text-slate-900 mb-2">Insurance Marketplace</h3>
              <p className="text-slate-600 mb-4">
                Get quotes from trusted insurance providers
              </p>
              <p className="text-sm text-slate-500">
                This feature will connect you directly with insurance providers for instant quotes
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
